module.exports = __webpack_public_path__ + "img/icon-simple-star.12aa7bdc.svg";